import { actionTypes } from 'app/constants/AnalyticsGa4Constants';

const setSearchOrigin = ({ searchOrigin }) => {
  return {
    type: actionTypes.SET_SEARCH_ORIGIN,
    payload: { searchOrigin }
  };
};

const trackEventCalendarAdd = ({ eventId, ui }) => {
  return {
    type: actionTypes.TRACK_EVENT_CALENDAR_ADD,
    payload: {
      eventId,
      ui
    }
  };
};

const trackCatalogExplore = ({ bib = null, bibId = null, metadata, search = null, ui }) => {
  if (!(bib || bibId)) {
    throw new Error('One of bib or bibId is required');
  }

  return {
    type: actionTypes.TRACK_CATALOG_EXPLORE,
    payload: {
      bib,
      bibId,
      metadata,
      search,
      ui
    }
  };
};

const trackCatalogSearch = ({ search, ui }) => {
  return {
    type: actionTypes.TRACK_CATALOG_SEARCH,
    payload: {
      search,
      ui
    }
  };
};

const trackCheckoutConsumeAccess = ({ bibId, ui = null }) => {
  return {
    type: actionTypes.TRACK_CHECKOUT_CONSUME_ACCESS,
    payload: {
      bibId,
      ui
    }
  };
};

const trackCheckoutConsumeDownload = ({ bibId, ui = null }) => {
  return {
    type: actionTypes.TRACK_CHECKOUT_CONSUME_DOWNLOAD,
    payload: {
      bibId,
      ui
    }
  };
};

const trackContentClick = ({
  bib = null,
  bibId = null,
  card = null,
  cardId = null,
  event = null,
  isSdk = false,
  list = null,
  listId = null,
  metadata = null,
  properties = null,
  search = null,
  ui = null
}) => {
  return {
    type: actionTypes.TRACK_CONTENT_CLICK,
    payload: {
      bib,
      bibId,
      card,
      cardId,
      event,
      isSdk,
      list,
      listId,
      metadata,
      properties,
      search,
      ui
    }
  };
};

const trackContentCollectionMove = ({ bibId, properties, ui = null }) => {
  return {
    type: actionTypes.TRACK_CONTENT_COLLECTION_MOVE,
    payload: {
      bibId,
      properties,
      ui
    }
  };
};

const trackContentEngageLike = ({ list, ui }) => {
  return {
    type: actionTypes.TRACK_CONTENT_ENGAGE_LIKE,
    payload: {
      list,
      ui
    }
  };
};

const trackContentExplore = ({
  bibId = null,
  card = null,
  cardId = null,
  event = null,
  list = null,
  location = null,
  metadata = null,
  properties = null,
  search = null,
  ui = null
}) => {
  return {
    type: actionTypes.TRACK_CONTENT_EXPLORE,
    payload: {
      bibId,
      card,
      cardId,
      event,
      list,
      location,
      metadata,
      properties,
      search,
      ui
    }
  };
};

const trackContentImpression = ({
  card = null,
  cardId = null,
  list = null,
  listId = null,
  properties,
  search = null,
  ui
}) => {
  return {
    type: actionTypes.TRACK_CONTENT_IMPRESSION,
    payload: {
      card,
      cardId,
      list,
      listId,
      properties,
      search,
      ui
    }
  };
};

const trackEventInterested = ({ cardId = null, event, properties = null, search, ui }) => {
  return {
    type: actionTypes.TRACK_EVENT_INTERESTED,
    payload: {
      cardId,
      event,
      properties,
      search,
      ui
    }
  };
};

const trackEventPdfCreate = ({ ui }) => {
  return {
    type: actionTypes.TRACK_EVENT_PDF_CREATE,
    payload: {
      ui
    }
  };
};

const trackEventSearch = ({ searchQuery }) => {
  return {
    type: actionTypes.TRACK_EVENT_SEARCH,
    payload: {
      searchQuery
    }
  };
};

const trackHoldingsConsumeAccess = ({ bibId = null, metadata, search = null, ui }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_CONSUME_ACCESS,
    payload: {
      bibId,
      metadata,
      search,
      ui
    }
  };
};

const trackHoldingsExplore = ({ bib, ui }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_EXPLORE,
    payload: { bib, ui }
  };
};

const trackHoldingsExploreEdition = ({ bibId, ui }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_EXPLORE_EDITION,
    payload: { bibId, ui }
  };
};

const trackHoldingsExploreFormat = ({ bibId, ui }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_EXPLORE_FORMAT,
    payload: { bibId, ui }
  };
};

const trackHoldingsView = ({ bibId, search = null, ui }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_VIEW,
    payload: {
      bibId,
      search,
      ui
    }
  };
};
const trackHoldingsWayfinderView = ({ bibId, ui, metadata, location }) => {
  return {
    type: actionTypes.TRACK_HOLDINGS_WAYFINDER_VIEW,
    payload: {
      bibId,
      ui,
      metadata,
      location
    }
  };
};
const trackNavigate = ({ isSdk = false, metadata, ui }) => {
  return {
    type: actionTypes.TRACK_NAVIGATE,
    payload: {
      isSdk,
      metadata,
      ui
    }
  };
};

const trackRequestExternalPlace = ({ bibId, metadata, ui }) => {
  return {
    type: actionTypes.TRACK_REQUEST_EXTERNAL_PLACE,
    payload: { bibId, metadata, ui }
  };
};

const trackPagePrint = ({ isSdk = false } = {}) => {
  return {
    type: actionTypes.TRACK_PAGE_PRINT,
    payload: { isSdk }
  };
};

const trackPageView = ({ bibId, eventId, isSdk = false, list }) => {
  return {
    type: actionTypes.TRACK_PAGE_VIEW,
    payload: {
      bibId,
      eventId,
      isSdk,
      list
    }
  };
};

export {
  setSearchOrigin,
  trackEventCalendarAdd,
  trackCatalogExplore,
  trackCatalogSearch,
  trackCheckoutConsumeAccess,
  trackCheckoutConsumeDownload,
  trackContentCollectionMove,
  trackContentClick,
  trackContentEngageLike,
  trackContentExplore,
  trackContentImpression,
  trackEventInterested,
  trackEventPdfCreate,
  trackEventSearch,
  trackHoldingsConsumeAccess,
  trackHoldingsExplore,
  trackHoldingsExploreEdition,
  trackHoldingsExploreFormat,
  trackHoldingsView,
  trackHoldingsWayfinderView,
  trackNavigate,
  trackPagePrint,
  trackPageView,
  trackRequestExternalPlace
};
